import * as AbsintheSocket from '@absinthe/socket'
import { ApolloLink } from '@apollo/client'
import { Socket as PhoenixSocket } from 'phoenix'

import first from 'lodash/first'

import { getAccessToken } from 'Services/Store/auth'

import createAbsintheSocketLink from './absintheSocketLink'

export default class ChatSubscriptionLink extends ApolloLink {
  socket

  token

  url

  constructor(path) {
    super()

    this.token = getAccessToken()

    if (this.token) {
      this.createSubscriptionClient(path)
    }
  }

  request(operation, forward) {
    if (!this.url) return null

    return this.url.request(operation, forward)
  }

  createSubscriptionClient(path) {
    const phoenixSocket = new PhoenixSocket(path, {
      params: () => ({ token: this.token }),
      reconnectAfterMs: () => 5000,
    })

    this.socket = AbsintheSocket.create(phoenixSocket)

    this.url = createAbsintheSocketLink(this.socket)
  }

  onTokenChanged(token) {
    if (token !== this.token) {
      this.token = token

      if (this.socket) {
        this.socket.phoenixSocket.disconnect()

        const firstChannel = first(this.socket.phoenixSocket.channels)
        if (firstChannel) firstChannel.leave()

        if (this.token) {
          this.socket.channel = this.socket.phoenixSocket.channel(
            '__absinthe__:control',
          )
          this.socket.channelJoinCreated = false
          this.socket.phoenixSocket.connect()
        }
      } else if (this.token) {
        this.createSubscriptionClient()
      }
    }
  }
}
